
export const testResponseAuth = response => {
    if (response?.status === 401) {
        window.location = "/401";
    }
}
